import { useMemo } from 'react';

import type { HeaderFeaturesType } from './ContentTypesHeaderFeatures.tsx';

type Params = {
	allowedFeatures: HeaderFeaturesType;
	/** Whether a replacement title is being rendered in place of the breadcrumbs. */
	hasAccessLinkTitle: boolean;
	isAccessLinkViewer: boolean;
};

/**
 * Narrows the header's allowed features for a viewer arriving through an Access Link.
 *
 * Breadcrumbs are hidden when a replacement title is present, because the trail names ancestor
 * pages the viewer cannot open. Watch is hidden always: its query requests `space.operations`,
 * which is denied for external shares, so the toggle cannot work and should not be offered.
 *
 * Returns `allowedFeatures` unchanged for everyone else.
 */
export const useAccessLinkResolvedFeatures = ({
	allowedFeatures,
	hasAccessLinkTitle,
	isAccessLinkViewer,
}: Params): HeaderFeaturesType =>
	useMemo(() => {
		let features = allowedFeatures;
		if (hasAccessLinkTitle) {
			features = { ...features, showBreadcrumbs: false };
		}
		if (isAccessLinkViewer) {
			features = { ...features, showWatchDialog: false };
		}
		return features;
	}, [allowedFeatures, hasAccessLinkTitle, isAccessLinkViewer]);
